import styled from 'styled-components';
import { Input, Button, Divider } from 'antd';
import { Link } from 'react-router-dom';

// 页面容器基础样式
export const PageContainer = styled.div`
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 16px;
    min-height: calc(100vh - 56px);
  }
`;

// 卡片基础样式
export const Card = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 40px;
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    padding: 24px;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 20px;
    border-radius: 12px;
  }
`;

// 页面标题样式
export const PageTitle = styled.h1`
  color: #fff;
  text-align: center;
  margin-bottom: 24px;
  font-size: 28px;
  
  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 20px;
  }
`;

// 表单基础样式
export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

// 输入框基础样式
export const StyledInput = styled(Input)`
  background: rgba(255, 255, 255, 0.1);
  border: none;
  height: 40px;
  color: #fff !important;
  font-size: 16px;
  
  @media (max-width: 480px) {
    height: 44px;
    font-size: 16px;
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  
  &:focus,
  &:hover {
    background: rgba(255, 255, 255, 0.15) !important;
  }

  input {
    background: transparent !important;
    color: #fff !important;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }
`;

// 密码输入框样式
export const StyledPassword = styled(Input.Password)`
  &.ant-input-affix-wrapper {
    background: rgba(255, 255, 255, 0.1) !important;
    border: none !important;
    height: 40px;
    color: #fff !important;
    padding: 0 11px;
    
    @media (max-width: 480px) {
      height: 44px;
      font-size: 16px;
    }
    
    &:hover {
      background: rgba(255, 255, 255, 0.15) !important;
    }
    
    &:focus,
    &-focused {
      background: rgba(255, 255, 255, 0.15) !important;
      box-shadow: none !important;
    }
    
    .ant-input {
      background: transparent !important;
      color: #fff !important;
      height: 100%;
      
      &::placeholder {
        color: rgba(255, 255, 255, 0.5);
      }
    }
    
    .ant-input-password-icon {
      color: rgba(255, 255, 255, 0.5);
      font-size: 16px;
      
      @media (max-width: 480px) {
        font-size: 18px;
      }
      
      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
`;

// 链接容器样式
export const LinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  flex-wrap: wrap;
  gap: 8px;
  
  @media (max-width: 480px) {
    margin-top: 12px;
  }
`;

// 链接样式
export const StyledLink = styled(Link)`
  color: #888;
  font-size: 14px;
  padding: 4px 0;
  
  @media (max-width: 480px) {
    font-size: 15px;
    padding: 6px 0;
  }
  
  &:hover {
    color: #fff;
  }
`;

// 分隔线样式
export const StyledDivider = styled(Divider)`
  &.ant-divider {
    color: rgba(255, 255, 255, 0.5);
    border-color: rgba(255, 255, 255, 0.2);
    margin: 8px 0;
    
    &::before, &::after {
      border-color: rgba(255, 255, 255, 0.2) !important;
    }
    
    @media (max-width: 480px) {
      margin: 12px 0;
    }
  }
`;

// 响应式按钮基础样式
export const ResponsiveButton = styled(Button)`
  height: 40px;
  font-size: 16px;
  
  @media (max-width: 480px) {
    height: 44px;
    font-size: 16px;
  }
`;

// 错误消息样式
export const ErrorMessage = styled.div`
  color: #ff4d4f;
  margin-bottom: 8px;
  text-align: center;
  font-size: 14px;
  
  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

// 内容区域基础样式
export const ContentSection = styled.section`
  padding: 40px 20px;
  
  @media (max-width: 768px) {
    padding: 32px 16px;
  }
  
  @media (max-width: 480px) {
    padding: 24px 12px;
  }
`;

// 响应式网格容器
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  
  @media (max-width: 768px) {
    gap: 20px;
  }
  
  @media (max-width: 480px) {
    gap: 16px;
  }
`;

// 响应式图片容器
export const ImageContainer = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  @media (max-width: 768px) {
    border-radius: 6px;
  }
`; 